import { Icon } from 'src/assets/svg/Icon'
import { Typography } from 'src/components/common/Typography'
import { Noto_body2_b14 } from 'src/styles/fonts/NotoSansKrFonts'
import RenderIf from 'src/components/common/RenderIf'
import StoreInfoCard from 'src/pages/CouponMapPage/_components/StoreInfoCard'
import React from 'react'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import { layoutMaxSize } from 'src/styles/mixin'

import { CouponMapProps } from 'src/pages/CouponMapPage'
import { fadeTransitionProps } from 'src/styles/animation'
import { motion } from 'framer-motion'

const MapBottomContents = (props: CouponMapProps) => {
  const {
    handleBottomSheetOpen,
    handleSearchStoresByBrandList,
    getCurrentLocationInfo,
    selectedStore,
    searchBrandList,
    searchCurrentLocationStore,
  } = props

  return (
    <S.MapBottomContentsContainer>
      <S.MapBottomFunctionalContainer>
        {/*필터 토글 아이콘*/}
        <S.IconContainer>
          <RenderIf when={searchBrandList?.length === 0}>
            <Icon.FilterToggleDefault onClickFn={handleBottomSheetOpen} />
          </RenderIf>
          <RenderIf when={searchBrandList?.length !== 0}>
            <Icon.FilterToggleActive onClickFn={handleBottomSheetOpen} />
          </RenderIf>
        </S.IconContainer>
        {/*현위치 매장보기*/}
        <RenderIf when={searchCurrentLocationStore && searchBrandList?.length !== 0}>
          <S.SearchCurLocation
            $option="flex_row"
            $column_gap="10px"
            $width="fit-content"
            {...fadeTransitionProps}
            as={motion.div}
            onClick={handleSearchStoresByBrandList}
          >
            <Icon.MapReFresh />
            <Typography $fontStyle={Noto_body2_b14} $color="var(--brand-50)">
              현 위치 매장 보기
            </Typography>
          </S.SearchCurLocation>
        </RenderIf>
        {/*현재위치 바로가기 아이콘*/}
        <S.IconContainer>
          <Icon.CurrentPosition onClickFn={getCurrentLocationInfo} />
        </S.IconContainer>
      </S.MapBottomFunctionalContainer>
      {/*매장정보*/}
      <RenderIf when={!!selectedStore}>
        <StoreInfoCard {...props} />
      </RenderIf>
    </S.MapBottomContentsContainer>
  )
}

export default MapBottomContents

const S = {
  MapBottomContentsContainer: styled(Container)`
    position: absolute;
    bottom: 0;
    ${layoutMaxSize};
    z-index: 2;
    display: flex;
    flex-direction: column;
  `,
  MapBottomFunctionalContainer: styled(Container)`
    padding: 0 20px 10px 20px;
    left: 50%;
    transform: translate(-50%, 0%);
    position: relative;
    z-index: 2;
    align-items: center;
    justify-content: space-between;
    display: flex;
    background: transparent;
  `,

  SearchCurLocation: styled(Container)`
    border-radius: 100px;
    outline: 1.5px solid var(--brand-50);
    background: var(--white);
    box-shadow: 0 2px 6px 0 rgba(0, 131, 252, 0.4);
    padding: 10px 16px;
    align-items: center;
    cursor: pointer;
  `,
  FilterOpenIcon: styled(Container)<{ $active: boolean }>`
    width: 44px;
    height: 44px;
    ${layoutMaxSize};
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 100px;
    position: relative;
    cursor: pointer;
    &::after {
      color: red;
      content: '•';
      display: ${(props) => (props.$active ? 'inline-block' : 'none')};
      font-size: 40px;
      position: absolute;
      top: 0;
      right: -1px;
      line-height: 6px;
    }
  `,
  IconContainer: styled(Container)`
    width: fit-content;
    border-radius: 100px;
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  `,
}
